import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getRegion = async () => {
  try {
    const response = await get<ApiResponse<[]>>(`/user/regions`).then((res) => {
      if (res?.success === true) {
        // console.log(res, "res");
        return res;
      } else {
        return null;
      }
    });
    return response;
  } catch (error) {
    HandleApiError(error);
  }
};
